import { Text } from '@americastestkitchen/mise';
import { IngredientGroups } from 'types/api/recipe.types';
import { PrintFontOptions } from 'types/recipe';
import RecipeIngredients from '../RecipeIngredients';
import styles from './RecipeIngredientGroup.module.scss';

type RecipeIngredientGroupProps = {
  recipeIngredientGroup: IngredientGroups;
  viewContext: string;
  printSize?: PrintFontOptions;
};

const RecipeIngredientGroup: React.FC<RecipeIngredientGroupProps> = ({
  recipeIngredientGroup,
  viewContext,
  printSize,
}) => {
  return (
    <>
      <Text variant="labelSecondary" weight="bold">
        {recipeIngredientGroup.fields.title}
      </Text>
      <div className={styles.group}>
        <RecipeIngredients
          recipeIngredientGroups={[recipeIngredientGroup]}
          recipeIngredientItems={
            recipeIngredientGroup.fields.recipeIngredientItems
          }
          siteKey="atk"
          viewContext={viewContext}
          printSize={printSize}
        />
      </div>
    </>
  );
};

export default RecipeIngredientGroup;
